/* Home V2: orbits — the CWE model (section 04).
   The diagram is stationary (positions come straight from the markup); this
   file only wires the two click targets:
     - a pillar bubble (data-pillar-index) opens its panel in the capability
       systems section (#pe-systems) via the PEHomeV2.openPillar hook, with a
       sessionStorage 'hv2OpenPillar' fallback read by 30-pillars.js at init;
     - the outer ring (data-goto="method") jumps to the four boards
       (#pe-method). */
(function () {
  'use strict';

  var root = document.getElementById('pe-model');
  if (!root) { return; }

  var svg = root.querySelector('#orbitSvg');
  if (!svg) { return; }

  var reduce = window.PEHomeV2 && window.PEHomeV2.reduce;

  /* Pillar entrance + loop: the three bubbles slide in from the outer ring to
     their resting cluster (CSS transition on .hv2-sphere.hv2-pillars-go). This
     is deliberately NOT tied to the generic .rv reveal (which fires the instant
     the diagram peeks in at the bottom of the viewport); instead we watch the
     diagram itself and only run while it is actually on screen.

     Once in view the entrance keeps replaying on a timer: slide in, hold
     settled for HOLD_MS (10s), retract to the ring, then slide back in — over
     and over, until the diagram scrolls away (which clears the timer and
     resets). The overlap-lens opacity is tied to the same class, so the
     gradients fade out during the retract and back in once the discs re-settle. */
  var sphere = root.querySelector('#sphere');
  if (sphere) {
    var IN_MS   = 2100;  // entrance slide (matches the CSS transform transition)
    var HOLD_MS = 10000; // settled dwell before each replay
    var OUT_MS  = 2100;  // retract to the ring (matches the CSS transition)
    var loopTimer = null;
    var go    = function () { sphere.classList.add('hv2-pillars-go'); };
    var reset = function () { sphere.classList.remove('hv2-pillars-go'); };

    var playThenWait = function () {
      go();                                              // slide in
      loopTimer = setTimeout(function () {
        reset();                                         // retract to the ring
        loopTimer = setTimeout(playThenWait, OUT_MS);    // then replay the entrance
      }, IN_MS + HOLD_MS);
    };
    var startLoop = function () { if (loopTimer === null) { playThenWait(); } };
    var stopLoop  = function () {
      if (loopTimer !== null) { clearTimeout(loopTimer); loopTimer = null; }
      reset();
    };

    if (reduce || !('IntersectionObserver' in window)) {
      go(); // reduced motion / no observer: show settled, do not loop
    } else {
      var pio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.intersectionRatio >= 0.5) { startLoop(); }
          else if (!e.isIntersecting) { stopLoop(); }
        });
      }, { threshold: [0, 0.5] });
      pio.observe(sphere);
    }
  }

  function activate(g) {
    /* scrollId = where we scroll the viewport to; hashId = the URL fragment;
       block = how the target aligns in the viewport. */
    var scrollId = 'pe-method';
    var hashId = 'pe-method';
    var block = 'start';

    if (!g.classList.contains('hv2-orbit-cwe')) {
      var idx = g.getAttribute('data-pillar-index');
      if (idx !== null) {
        /* Open the pillar now if 30-pillars.js has exposed its hook; otherwise
           leave a flag it reads at init (covers script-order / cross-page). */
        if (window.PEHomeV2 && typeof window.PEHomeV2.openPillar === 'function') {
          window.PEHomeV2.openPillar(idx);
        } else {
          try { sessionStorage.setItem('hv2OpenPillar', String(idx)); } catch (e) { /* private mode */ }
        }
      }
      scrollId = 'pillars';
      hashId = 'pe-systems';
    }

    var target = document.getElementById(scrollId) || document.getElementById(hashId);
    if (target) {
      var behavior = reduce ? 'auto' : 'smooth';
      if (scrollId === 'pillars') {
        /* Land the opened panel with its BOTTOM at the fold, so the section
           ends at the bottom of the screen — but never scroll so far that the
           panel head goes behind the fixed header (short viewports keep the
           head + first offering visible). Uses the panel's FULL height
           (inner.offsetHeight, available immediately) rather than its
           mid-animation height, which scrollIntoView(block:'end') would misread. */
        var openEl = target.querySelector('.pillar.is-open');
        var inner = openEl && openEl.querySelector('.p-inner');
        var fullH = inner ? inner.offsetHeight : target.offsetHeight;
        var topAbs = target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
        var bottomAlignY = topAbs + fullH - window.innerHeight + 24; /* 24px gap above the fold */
        var topAlignY = topAbs - 80; /* head just clear of the 60px fixed header */
        window.scrollTo({ top: Math.max(0, Math.min(bottomAlignY, topAlignY)), behavior: behavior });
      } else if (target.scrollIntoView) {
        target.scrollIntoView({ behavior: behavior, block: block });
      }
    }
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#' + hashId);
    } else {
      window.location.hash = hashId;
    }
  }

  function closestTarget(el) {
    return el && el.closest ? el.closest('.hv2-orbit-pillar, .hv2-orbit-cwe') : null;
  }

  svg.addEventListener('click', function (e) {
    var g = closestTarget(e.target);
    if (g) { activate(g); }
  });
  svg.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') { return; }
    var g = closestTarget(e.target);
    if (!g) { return; }
    e.preventDefault();
    activate(g);
  });
})();
